import { ChargeResponse } from './model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<ChargeResponse> {
  isLoaded: boolean
}

export const adapter: EntityAdapter<ChargeResponse> = createEntityAdapter<ChargeResponse>({
  sortComparer: (a, b) => a.created - b.created,
  selectId: (t: ChargeResponse) => t.pkey,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
})
